export const data = [
  {
    activeLiquidity: 3,
    price0: 0.9
  },
  {
    activeLiquidity: 8,
    price0: 1
  },
  {
    activeLiquidity: 18,
    price0: 1.1
  },
  {
    activeLiquidity: 1,
    price0: 1.15
  },
  {
    activeLiquidity: 3,
    price0: 1.2
  },
  {
    activeLiquidity: 2,
    price0: 1.5
  }
]
